import { useContext } from 'react'
import AuthContext, { IAuthContext } from '@providers/AuthProvider'

export default function useAuth() {
  const AuthValues = useContext<IAuthContext>(AuthContext)

  return AuthValues
}
